import PaymentMethod from "./PaymentMethod";

/**
 * 📄 Model representing the OBT payment method the user uses to pay the subscription
 */
export default class OBTPaymentMethod implements PaymentMethod {}